<!--
 * @Author: your name
 * @Date: 2020-06-29 16:10:51
 * @LastEditTime: 2020-08-07 11:33:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-web\src\components\Index\Index.vue
--> 
<template>
  <div class="payRecord-wrap" 
    v-loading="loading"
    element-loading-text="正在查询您的缴费记录，请稍等"
    element-loading-spinner="el-icon-loading">
    <div class="payRecord-Succeed" v-if="payFlag">
      <div class="payRecord-back">
        <div class="payRecord-back-box"></div>
      </div>
      <div class="payRecord-content">
        <div class="payRecord-top">
          <div class="payRecord-box" v-for="item in payRecord" :key="item.id">
            <div v-if="item.insuranceFlag" style="width: 100%;display:flex">
              <div class="payRecord-left">
                <div class="payRecord-content-left"><img src="../../../assets/image/leak-icon.png" alt="" style="width: 100%;height:100%"></div>
                <div class="payRecord-content-right">
                  <div style="color: #007B83;">跑漏险</div>
                  <div style="font-size: 0.12rem;">卡号:{{item.heating_card_num}}</div>
                  <div style="font-size: 0.12rem;">{{item.payment_time}}</div>
                </div>
              </div>
              
              <div class="payRecord-right">
                <div style="color:#007B83">{{item.payment_money ? '￥' + item.payment_money : ''}}元</div>
              </div>
            </div>
            <div v-else style="width: 100%;display:flex">
              <div class="payRecord-left">
                <div class="payRecord-content-left"><img src="../../../assets/image/bask-icon.png" alt="" style="width: 100%;height:100%"></div>
                <div class="payRecord-content-right">
                  <div style="color: #FFA95F;">取暖费</div>
                  <div style="font-size: 0.12rem;">卡号:{{item.heating_card_num}}</div>
                  <div style="font-size: 0.12rem;">{{item.payment_time}}</div>
                </div>
              </div>
              <div class="payRecord-right">
                <div style="color:#FFA95F">{{item.payment_money ? '￥' + item.payment_money : ''}}元</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="payRecord-Fail" v-else>
      <div style="margin-top:1.5rem;"><img src="../../../assets/image/recordfail.png" alt="" style="margin:0 auto;width:1.5rem"></div>
      <div style="color: #007B83;text-align:center;margin-top:0.2rem;">暂无缴费记录</div>
      <div style="text-align:center;margin-top:0.5rem;">
        <el-button style="background: #007B83;color:#fff;width:2.7rem;border:none;padding:4%;" @click="goPayMent">去缴费</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: 'payRecord',
  data(){
    return{
      payFlag:true,
      insuranceFlag:'',// true 跳转跑漏险缴费 false 跳转供暖缴费
      loading:'',
      payRecord:[],// 缴费记录
    }
  },

  methods:{
    // 获取缴费记录
    async getPayRecord(){
      let payRecord; // 所有缴费记录
      const heatingRes = await this.$http.get(`${this.$url.globalurl}/wxPayRecord`);
      heatingRes.result.forEach(i=>{
        i.payment_time = moment(i.pay_time).format("YYYY-MM-DD HH:mm")
      })
      const insuranceRes = await this.$http.get(`${this.$url.globalurl}/wxPayRecord`,{
        data:{
          insurance:true
        }
      });
      
      if(heatingRes.result.length){
        payRecord = heatingRes.result;
      }else if(insuranceRes.result.length){
        payRecord = insuranceRes.result;
      }
      if(!insuranceRes.result.length && !heatingRes.result.length){
        this.loading = false;
        return this.payFlag = false; 
      }
      this.loading = false;
      this.payFlag = true;
      if(heatingRes.result.length){// 将两个记录进行排序放入一个数组
        for(let i = 0; i < insuranceRes.result.length; i++){
          insuranceRes.result[i].payment_time = moment(insuranceRes.result[i].pay_time).format("YYYY-MM-DD HH:mm");
          insuranceRes.result[i].insuranceFlag = true;
          for(let j = 0; j < heatingRes.result.length; j++){
            if(moment(insuranceRes.result[i].pay_time).isAfter(heatingRes.result[j].payment_time)){
              payRecord.splice(j,0,insuranceRes.result[i]);
              break; 
            }
            if(j === heatingRes.result.length - 1){ // 如果循环到最后一次还是没有比当前数据时间早的
              payRecord.push(insuranceRes.result[i]);
              break;
            }
          }
        }
      }else{// 如果进入这里则证明，只有跑路险记录
        for(let i = 0; i < insuranceRes.result.length; i++){
          insuranceRes.result[i].payment_time = moment(insuranceRes.result[i].pay_time).format("YYYY-MM-DD HH:mm")
          insuranceRes.result[i].insuranceFlag = true;
        }
      }
      this.payRecord = payRecord;
    },
    // 回到缴费页面
    goPayMent(){
      this.$router.push({
        name:'index'
      })
    }
  },

  mounted(){
    if(this.$route.query){
      this.insuranceFlag = this.$route.query.insuranceFlag;
    }
    this.loading = true;
    this.getPayRecord();
    document.title = "缴费记录";
  }
}
</script>
<style lang='scss' scoped>
@import url(payRecord.scss);
</style>
